import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  RowWrapper,
  Section,
  SectionTitle,
  UserFormProps,
} from '../../../components/AdminFormComponents';

export const AIUserFeaturesSection = (props: UserFormProps) => {
  const {
    values,
    setFieldValue,
    isSubmitting,
    isAISpotlightEnabledForCustomer,
    isAIAssistantEnabledForCustomer,
  } = props;
  return (
    <Section id='aiUserFeaturesSection'>
      <SectionTitle>AI</SectionTitle>
      <RowWrapper>
        {/* AI SPOTLIGHT */}
        {isAISpotlightEnabledForCustomer && (
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='spotlightEnabled'
            label='AI Spotlights'
            onChange={() => {
              setFieldValue('spotlightEnabled', !values.spotlightEnabled);
            }}
            disabled={isSubmitting}
          />
        )}
        {/* AI ASSISTANTS */}
        {isAIAssistantEnabledForCustomer && (
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='quickVideoAvatarEnabled'
            label='AI Assistant'
            onChange={() => {
              setFieldValue(
                'quickVideoAvatarEnabled',
                !values.quickVideoAvatarEnabled
              );
            }}
            disabled={isSubmitting}
          />
        )}
      </RowWrapper>
    </Section>
  );
};
